import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg' // adjust path if needed

function RecentStatusDate ({
  mostRecentStatusDateFilter,
  setMostRecentStatusDateFilter
}) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleStartDateChange = e => {
    setMostRecentStatusDateFilter({
      startDate: e.target.value,
      endDate: mostRecentStatusDateFilter.endDate
    })
  }

  const handleEndDateChange = e => {
    setMostRecentStatusDateFilter({
      startDate: mostRecentStatusDateFilter.startDate,
      endDate: e.target.value
    })
  }

  return (
    <div className={styles.RecentStatusDateContainer}>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.RecentStatusDateTitle}>
          Most recent status date
        </h1>
        <Tooltip
          title="Filter by when the date a property’s most recent status was last recorded. Set a start and/or end date."
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Most recent status date info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>
      <div className={styles.RecentStatusDateInputContainer}>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='startDate'
          max={maxDate}
          value={mostRecentStatusDateFilter.startDate}
          onChange={handleStartDateChange}
          required
        />
        <span className={styles.RecentStatusDateLabel}>to</span>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='endDate'
          max={maxDate}
          value={mostRecentStatusDateFilter.endDate}
          onChange={handleEndDateChange}
          required
        />
      </div>
    </div>
  )
}

export default RecentStatusDate
